module.exports = __webpack_public_path__ + "static/media/21.e8e2d96f.avif";